import ChangeProfilePicture from "./ChangeProfilePicture"
import EditProfile from "./EditProfile"
import DeleteAccount from "./DeleteAccount"
import UpdatePassword from "./UpdatePassword"
import {Settings as Setting} from "lucide-react"

export default function Settings() {
    return (
        <div className="bg-gradient-to-br from-slate-50 via-white to-blue-50/30 py-8 px-4 ">
            <div className="flex items-center gap-3">
            <Setting className="h-8 w-8 text-blue-500"/>
            <h1 className="text-4xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">Settings</h1>
           </div>
            {/* change profile picture */}
            <ChangeProfilePicture/>
            {/* edit profile */}
            <EditProfile/>
            {/* password */}
            {/* <UpdatePassword/> */}
            {/* delete account */}
            <DeleteAccount/>
        </div>
    )
}



// import ChangeProfilePicture from "./ChangeProfilePicture"
// import EditProfile from "./EditProfile"
// import DeleteAccount from "./DeleteAccount"
// import UpdatePassword from "./UpdatePassword"

// export default function Settings() {
//     return (
//         <div>
//             <h1 className="mb-14 text-3xl font-medium text-richblack-800 ml-16 md:ml-0">Edit Profile</h1>
//             {/* change profile picture */}
//             <ChangeProfilePicture/>
//             {/* edit profile */}
//             <EditProfile/>
//             {/* password */}
//             {/* <UpdatePassword/> */}
//             {/* delete account */}
//             <DeleteAccount/>
//         </div>
//     )
// }
